import React, { useContext } from 'react'
import { BrowserRouter, useLocation, useMatch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { ToastContainer } from 'react-toastify'

import Header from 'features/Header'
import Sidebar from 'features/Sidebar'
import {
  SITES_MAP_PATH,
  SITE_PROPOSAL_ABOUT_PATH,
  CHANGE_PASSWORD_PATH,
  FORGOT_PASSWORD_PATH,
  LOGIN_PATH,
  PROFILE_PATH,
  SITE_PROPOSAL_MONITORING_PATH,
  SITE_PROPOSAL_DETAILS_PATH,
  SITE_PROPOSAL_MAP_PATH,
  SITE_PROPOSAL_ASSESSMENT_PATH,
  SITE_PROPOSAL_CALCULATIONS_PATH,
  SITE_REASSESSMENT_CALCULATIONS_PATH,
  SITE_REASSESSMENT_ABOUT_PATH,
  SITE_REASSESSMENT_DETAILS_PATH,
  SITE_REASSESSMENT_MAP_PATH,
  SITE_REASSESSMENT_ASSESSMENT_PATH,
  SITE_REASSESSMENT_MONITORING_PATH, REPORTS_EXPAND_PATH,
  SITE_EDIT_ONLY_ABOUT_PATH,
  SITE_EDIT_ONLY_ASSESSMENT_PATH,
  SITE_EDIT_ONLY_CALCULATIONS_PATH,
  SITE_EDIT_ONLY_DETAILS_PATH,
  SITE_EDIT_ONLY_MAP_PATH,
  SITE_EDIT_ONLY_MONITORING_PATH,
} from 'routing/constants'
import { AuthContext } from 'providers/auth'

import AuthorizedApp from './authorizedApp'
import AnonymousApp from './anonymousApp'
import { FormattedMessage } from 'react-intl'

export const IsFullScreenContext = React.createContext(false)

const history = createBrowserHistory({})
const pagesWhereBackGroundIsOn = [LOGIN_PATH, FORGOT_PASSWORD_PATH, CHANGE_PASSWORD_PATH]

const Routing = () => {
  return (
    <BrowserRouter history={history}>
      <App />
    </BrowserRouter>
  )
}

const App = () => {
  const location = useLocation()
  const { isAuthenticated } = useContext(AuthContext)

  const matchMainSitesMapPath = useMatch(SITES_MAP_PATH)

  const matchAboutPath = useMatch(SITE_PROPOSAL_ABOUT_PATH)
  const matchMonitoringPath = useMatch(SITE_PROPOSAL_MONITORING_PATH)
  const matchSiteDetailsPath = useMatch(SITE_PROPOSAL_DETAILS_PATH)
  const matchSiteProposalMapPath = useMatch(SITE_PROPOSAL_MAP_PATH)
  const matchAssessmentPage = useMatch(SITE_PROPOSAL_ASSESSMENT_PATH)
  const matchCalculationsPage = useMatch(SITE_PROPOSAL_CALCULATIONS_PATH)
  const matchReassessmentCalculationPage = useMatch(SITE_REASSESSMENT_CALCULATIONS_PATH)
  const matchReassessmentAboutPage = useMatch(SITE_REASSESSMENT_ABOUT_PATH)
  const matchReassessmentDetailsPage = useMatch(SITE_REASSESSMENT_DETAILS_PATH)
  const matchReassessmentMapPage = useMatch(SITE_REASSESSMENT_MAP_PATH)
  const matchReassessmentAssessmentPage = useMatch(SITE_REASSESSMENT_ASSESSMENT_PATH)
  const matchReassessmentMonitoringPage = useMatch(SITE_REASSESSMENT_MONITORING_PATH)
  const matchReportExpandPage = useMatch(REPORTS_EXPAND_PATH)
  const matchEditOnlyDetailsPage = useMatch(SITE_EDIT_ONLY_DETAILS_PATH)
  const matchEditOnlyAboutPage = useMatch(SITE_EDIT_ONLY_ABOUT_PATH)
  const matchEditOnlyAssessmentPage = useMatch(SITE_EDIT_ONLY_ASSESSMENT_PATH)
  const matchEditCalculationsPage = useMatch(SITE_EDIT_ONLY_CALCULATIONS_PATH)
  const matchEditMapPage = useMatch(SITE_EDIT_ONLY_MAP_PATH)
  const matchEditMonitoringPage = useMatch(SITE_EDIT_ONLY_MONITORING_PATH)


  const fullScreenRouteMatch = [
    matchSiteProposalMapPath,
    matchReassessmentMapPage,
    matchMainSitesMapPath
  ].find((match) => {
    return Boolean(match?.pathname)
  })

  const navigationHiddenRouteMatch = [
    matchAboutPath,
    matchMonitoringPath,
    matchSiteDetailsPath,
    matchSiteProposalMapPath,
    matchAssessmentPage,
    matchCalculationsPage,
    matchReassessmentCalculationPage,
    matchReassessmentAboutPage,
    matchReassessmentDetailsPage,
    matchReassessmentMapPage,
    matchReassessmentAssessmentPage,
    matchReassessmentMonitoringPage,
    matchReportExpandPage,
    matchEditOnlyDetailsPage,
    matchEditOnlyAboutPage,
    matchEditOnlyAssessmentPage,
    matchEditCalculationsPage,
    matchEditMapPage,
    matchEditMonitoringPage
  ].find((match) => {
    return Boolean(match?.pathname)
  })

  const isFullScreen = Boolean(fullScreenRouteMatch)

  const mainWrapperStyle = isFullScreen ? {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  } : {
    width: '100%'
  }

  return (
    <div style={{ height: isFullScreen ? '100%' : 'initial' }}>
      <IsFullScreenContext.Provider value={isFullScreen}>
        <ToastContainer
          autoClose={5000}
          closeOnClick
          draggable
          hideProgressBar={true}
          newestOnTop={false}
          pauseOnFocusLoss
          pauseOnHover
          position='top-center'
          style={{
            width: '35%',
            height: '40px',
            padding: '0px'
          }}
          rtl={false}
        />
        {pagesWhereBackGroundIsOn.includes(location.pathname) ? (
          <div>
            <Header />
            <div className='login-form-container'>
              <div style={{ width: '100%' }}>{isAuthenticated ? <AuthorizedApp /> : <AnonymousApp />}</div>
            </div>
            <div className='page-background-frog-login-page'>
              <div className='login-page-text'>
                <FormattedMessage id='loginPageDescription' values={{ br: <br /> }} />
              </div>
              <div className='login-page-text-bottom'>
                <FormattedMessage id='loginBottomImageDescription' values={{ br: <br /> }} />
              </div>
            </div>
          </div>
        ) : (
          <div className='page-background'>
            {isAuthenticated && location.pathname !== PROFILE_PATH && !navigationHiddenRouteMatch && (
              <Sidebar />
            )}
            <div style={mainWrapperStyle}>
              {location.pathname !== PROFILE_PATH && !navigationHiddenRouteMatch && (
                <Header />
              )}
              {isAuthenticated ? <AuthorizedApp /> : <AnonymousApp />}
            </div>
          </div>
        )}
      </IsFullScreenContext.Provider>
    </div>
  )
}

export default Routing